import React from 'react';

function RecipeModal({ recipe, onClose }) {
  if (!recipe) {
    return null;
  }

  const formatRecipeText = (text) => {
    if (!text) return '';
    // Add newlines around headers
    let formatted = text.replace(/(Ingredients:)/gi, '\n\n$1\n');
    formatted = formatted.replace(/(Instructions:)/gi, '\n\n$1\n');
    // Add newlines before bullet points
    formatted = formatted.replace(/(\s-\s)/g, '\n- ');
    // Add newlines before numbered list items
    formatted = formatted.replace(/\s(\d+\.\s)/g, '\n$1');
    // Clean up excessive new lines
    formatted = formatted.replace(/\n{3,}/g, '\n\n');
    
    // Split to bolderize headers
    const parts = formatted.trim().split(/(Ingredients:|Instructions:)/gi);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'ingredients:' || part.toLowerCase() === 'instructions:') {
        return <strong key={index} style={{ fontSize: '1.2em', display: 'block', marginTop: '15px', marginBottom: '5px', color: '#2c3e50' }}>{part}</strong>;
      }
      return <span key={index}>{part}</span>;
    });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{recipe.name}</h2>
        <div className="recipe-body">
          {formatRecipeText(recipe.full)}
        </div>
        <button className="close-button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
}

export default RecipeModal;
